import { c as _c } from "react/compiler-runtime";
import { ErrorPage } from '@/components/Pages/Errors/ErrorPage';
import { ErrorPageTemplate } from '@/components/Templates/ErrorPageTemplate/ErrorPageTemplate';
export const Standalone500ErrorPage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorPageTemplate title="Error"><ErrorPage title="500" subtitle="Page Error" message={<>Try refreshing, or go to the <a href="/">BNEF home page</a>.</>} showDebugInfo={true} /></ErrorPageTemplate>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};